import _ from 'lodash'
import config from '../../lib/config'
const EventBus = window.VueEventBus

import PageMixins from '../../components/_mixins/pages'
import CartMixins from '../../components/_mixins/location-checkout'
import ScrollMixins from '../../components/_mixins/scroller'
import ContentMixins from './content'

import WouldYouLikeTo from '../../components/parts/would-you-like-to'

import CartBilling from './billing'
import CartFinal from './final'

import { required, minValue, maxValue, decimal, integer, email, sameAs } from 'vuelidate/lib/validators'
import axios from 'axios'
import MainService, { getFirstErrorMessage } from 'utils/vue/services/main'
import {raceType} from '../../vuexstore/modules/race'
import {parseDateTime, parseDateInterval} from '../../lib/dates'

const LOYALTY_POINT_EARN_RATIO = 'point_earning_ratio'
const LOYALTY_POINT_SPENDING_RATIO = 'point_spending_ratio'
const LOYALTY_DISCOUNT_TYPE = 'loyalty_program_points'
const LOYALTY_DISCOUNT_MAX_POINTS = 'max_points_per_order'
const LOYALTY_DISCOUNT_MIN_POINTS = 'min_points_per_order'

export default {
  name: 'page-cart',
  translations: 'page.cart',
  settings: 'page.cart',
  mixins: [
    PageMixins,
    CartMixins,
    ScrollMixins,
    ContentMixins
  ],

  components: {
    CartBilling,
    CartFinal,
    WouldYouLikeTo,
  },

  props: ['waiver'],

  data() {
    return {
      waiverUrl: null,
      loginUri: null,
      registerUri: null,
      generalAlertMessage: '',
      generalAlertMessages: [],
      showClearCartPrompt: false,
      showLoginPrompt: false,
      loginPromptText: 'Please sign in to your account to complete the billing.',
      showItemRates: false,
      showGiftcardFullPartialModal: false,
      showGiftcardAmountModal: false,
      acceptedCards: config.ACCEPTED_CARDS,
      columnClasses: {
        title: 'flex-child-grow',
        date: 'w10',
        quantity: 'w10',
        rate: 'w10',
        amount: 'w10',
        tax: 'w10',
        total: 'w10',
      },
      headerItem: {
        title: 'PRODUCT NAME',
        date: 'DATE & TIME',
        quantity: 'QUANTITY',
        rate: 'PRICE',
        amount: 'SUB TOTAL',
        tax: 'TAX',
        total: 'TOTAL',
      },
      giftcard: {
        number: null,
        cvv: null,
        amount: null,
        isAdding: false,
        error: null,
        isAdded: false,
        itemId: null,
        notApplied: false
      },
      coupon: {
        code: null,
        isAdding: false,
        error: null,
        isAdded: false,
        notApplied: false
      },
      loyalty: {
        points: null,
        isAdding: false,
        error: null,
        isAdded: false
      },
      // costDetails: {},
      items: null,
      order: null,
      showCheckoutAsGuestModal: false,
      guestEmailRegistered: false,
      guestEmail: null,
      guestEmailConfirmation: null,
      isCheckingGuestEmail: false,

      isSubmitting: false,
      isValidating: false,
      // valid: false,
      // validationError: null,
      selectedRedemption: this.$$s('redemption.default', 'coupon'),
      redemptionTypes: {
        coupon: {
          title: 'Coupon code'
        },
        giftcard: {
          title: 'Gift card'
        },
        loyalty: {
          title: 'Loyalty points'
        }
      }
    }
  },
  validations() {

    const loyaltyCanCheckBelowMin = !!this.$$s('loyaltyDiscount.validate.pointsBelowMin', true)
    const loyaltyCanCheckAboveMax = !!this.$$s('loyaltyDiscount.validate.pointsAboveMax', true)
    const loyaltyCanCheckAboveUser = !!this.$$s('loyaltyDiscount.validate.pointsAboveUser', true)
    const additionalLoyaltyRules = {}
    if (loyaltyCanCheckBelowMin) {
      additionalLoyaltyRules.minValue = minValue(this.loyaltyPointMinSpend)
    }

    if (loyaltyCanCheckAboveMax && !loyaltyCanCheckAboveUser) {
      additionalLoyaltyRules.maxValue = maxValue(this.loyaltyPointMaxSpend)
    }
    if (!loyaltyCanCheckAboveMax && loyaltyCanCheckAboveUser) {
      additionalLoyaltyRules.maxValue = maxValue(this.userLoyaltyPoints)
    }
    if (loyaltyCanCheckAboveMax && loyaltyCanCheckAboveUser) {
      additionalLoyaltyRules.maxValue = maxValue(this.loyaltyDiscountMaxPoints)
    }

    return {
      giftcard: {
        number: {
          required,
        },
        cvv: {
          required,
        },
        amount: {
          required,
          decimal,
          minValue: minValue(0.01),
          maxDecimals: v => ((Number(v).toFixed(2) - v) === 0),
        },
      },
      giftcardApplyGroup: [
        'giftcard.number', 'giftcard.cvv',
      ],
      coupon: {
        code: {
          required,
        },
      },
      loyalty: {
        points: {
          required,
          integer,
          ...additionalLoyaltyRules
        }
      },

      guestEmail: {
        required,
        email,
      },
      guestEmailConfirmation: {
        required,
        email,
        sameAs: sameAs('guestEmail'),
      },
      guest: [
        'guestEmail', 'guestEmailConfirmation'
      ],
    }
  },
  watch: {
    'coupon.code'(v) {
      this.coupon.error = null
    },
    'giftcard.number'(v) {
      this.giftcard.error = null
    },
    'giftcard.cvv'(v) {
      this.giftcard.error = null
    },
    'loyalty.points'(v) {
      this.loyalty.error = null
    },
    checkoutState: {
      handler: function (newValue, oldValue) {
        if (!newValue || newValue === 'cart') {
          this.$nextTick(() => {
            // console.log('go to cart page')
            this.scrollToTop()
          })
        }
      },
      immediate: true
    },
    authenticated(auth) {
      if (!auth) {
        // remove loyalty discount if logged out
        this.deleteLoyalty()
      }
    }
  },
  created() {
    // this.hideGlobalTimer(true)
    this.waiverUrl = this.waiver
    if (!this.isBillingStep) {
      this.setBillingTotal(false)
      this.setBillingGuestEmail(false)
      this.setCheckoutState('cart')
    }

    this.loginUri = this.getRouteUrl('page-login')
    this.registerUri = this.getRouteUrl('page-registration')
    EventBus.$on('cart.unauthenticated', () => {
        //this.showLoginPrompt = true
    })

    EventBus.$on('cart.error', x => {
      this.setCostDetails(null)
    })

    EventBus.$once('cart.validated', x => {
      this.setCostDetails(x)
      this.setValidationError()

      if (!this.currentCartIsEmpty && this.loginRedirectSection === 'billing') {
        this.setPostLoginSection(null)
        this.tryGotoBilling()
      }
    })
    EventBus.$on('cart.paying', () => {
      this.items = _.cloneDeep(this.currentCartItems)
    })
    EventBus.$on('cart.cleared', () => {
      this.stopTimer()
      this.setCostDetails(null)
      this.resetLoyaltyInput(true)
    })
    EventBus.$on('cart.paid', order => {
      this.order = order
      this.stopTimer()
      this.clearCartItems()
      this.setCostDetails(null)
      this.resetLoyaltyInput(true)

      if (this.authenticated) {
        this.fetchUser()
      }
    })

    EventBus.$on('cart.general.messages.collect', messages => {
      this.getOverlappingReservationMessages(messages)
    })

    EventBus.$emit('cart.general.messages.collect', this.generalAlertMessages)

    this.showGeneralAlert()

    if (!this.authenticated) {
      this.deleteLoyalty(true)
    } else {
      if (this.hasLoyaltyDiscountInStore && this.hasLoyaltyDiscountInSummary) {
        this.loyalty.isAdded = true
      } else {
        this.deleteLoyalty(true)
      }
    }
  },

  mounted() {
    const loginRedirectSection = this.loginRedirectSection
    const loginRedirectSubSection = this.loginRedirectSubSection

    if (!this.currentCartIsEmpty && loginRedirectSection === 'cart') {
      this.setPostLoginSection(null)
      if (loginRedirectSubSection) {
        this.$nextTick(() => {
          this.gotoSubSection(loginRedirectSubSection)
        })
      }
    }
  },
  computed: {
    isGeneralAlertVisible() {
      return !this.currentCartIsEmpty && !this.isAlertOnTimeoutShown && !this.showLoginPrompt && !this.showClearCartPrompt
    },
    isGeneralAlertShown() {
      return this.isGeneralAlertVisible && this.generalAlertMessage  && this.isGeneralAlertPopupShown
    },
    isBillingStep() {
      return this.checkoutState === 'billing' && this.isBillingError
    },
    billingEnabled() {
      return this.costDetails.total > 0
    },
    wouldYouLikeBlocks() {
      const blocks = this.getFilteredWouldYouLikeBlocks()
      return this.translateProductName(blocks, ['title', 'message'])
    },
    canShowLoyaltyRedemption() {
      const hasFeature = !!this.$$s('loyaltyDiscount.enabled', false)
      const showInGuestMode = !!this.$$s('loyaltyDiscount.showInGuestMode', true)
      const showForZeroPoints = !!this.$$s('loyaltyDiscount.showForZeroPoints', true)
      return hasFeature &&
        (showInGuestMode || this.authUser) &&
        (showForZeroPoints || this.userLoyaltyPoints > 0)
    },
    userLoyaltyPoints() {
      const allPoints = this.authUser?.loyalty_program_points || {}
      return allPoints[this.currentLocationId]
    },
    loyaltyPointEarnRatio() {
      return _.get(
        window.addiesaas.locations[this.currentLocationId],
        `settings.loyalty_program.${LOYALTY_POINT_EARN_RATIO}`,
        _.get(this.config?.loyalty_program, LOYALTY_POINT_EARN_RATIO, 1)
      )
    },
    loyaltyPointSpendRatio() {
      return _.get(
        window.addiesaas.locations[this.currentLocationId],
        `settings.loyalty_program.${LOYALTY_POINT_SPENDING_RATIO}`,
        _.get(this.config?.loyalty_program, LOYALTY_POINT_SPENDING_RATIO, 1)
      )
    },
    loyaltyPointMaxSpend() {
      return _.toFinite(_.get(
        window.addiesaas.locations[this.currentLocationId],
        `settings.loyalty_program.${LOYALTY_DISCOUNT_MAX_POINTS}`,
        _.get(this.config?.loyalty_program, LOYALTY_DISCOUNT_MAX_POINTS, 0)
      )) || Number.MAX_SAFE_INTEGER
    },
    loyaltyPointMinSpend() {
      return _.toFinite(_.get(
        window.addiesaas.locations[this.currentLocationId],
        `settings.loyalty_program.${LOYALTY_DISCOUNT_MIN_POINTS}`,
        _.get(this.config?.loyalty_program, LOYALTY_DISCOUNT_MIN_POINTS, 0)
      )) || 1
    },
    loyaltyDiscountMinPoints() {
      return Math.max(this.loyaltyPointMinSpend, this.loyaltyPointSpendRatio)
    },
    loyaltyDiscountMaxPoints() {
      return Math.min(this.loyaltyPointMaxSpend, this.userLoyaltyPoints)
    },
    loyaltyDiscountIsInsufficientPoints() {
      const points = this.userLoyaltyPoints
      return points > 0 && points < this.loyaltyDiscountMinPoints
    },
    hasAppliedRedemptions() {
      const summary = this.costDetails
      return summary && (
        this.coupons(summary).length ||
        this.giftcards(summary).length ||
        this.loyaltyDiscounts().length
      )
    },
    hasRedemptionErrors() {
      return !_.isEmpty(this.redemptionErrors || {})
    },
    errorsAfterValidation() {
      return _.reduce(this.validationErrors?.errors, (carry, item, path) => {
          _.set(carry, path, item)
          return carry
        }, {})
    },
    redemptionErrors() {
      return _.pick(this.errorsAfterValidation, ['discounts'])
    },
    loyaltyDiscountInStore() {
      return _.values(this.cartDiscounts).filter(d => d.type === LOYALTY_DISCOUNT_TYPE)
    },
    hasLoyaltyDiscountInSummary() {
      return !!this.loyaltyDiscounts().length
    },
    hasLoyaltyDiscountInStore() {
      return !!this.loyaltyDiscountInStore.length
    },
    loyaltyDiscountData() {
      return {
        ...this.loyalty,
        // plural = more than 1 points
        pluPoints: this.loyalty.points > 1,
        pluBalance: this.userLoyaltyPoints > 1,
        balance: this.userLoyaltyPoints,
        min: this.loyaltyDiscountMinPoints,
        realMin: this.loyaltyPointMinSpend,
        max: this.loyaltyDiscountMaxPoints,
        realMax: this.loyaltyPointMaxSpend,
        spendRatio: this.loyaltyPointSpendRatio,
        earnRatio: this.loyaltyPointEarnRatio,
      }
    },
    loyaltyDiscountTitle() {
      return this.$$t(
        'loyaltyDiscount.title',
        'Loyalty Points',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountAppliedMessage() {
      return this.$$t(
        'loyaltyDiscount.messages.applied',
        'Your loyalty points have been applied. ',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountRemoveButtonTitle() {
      return this.$$t(
        'loyaltyDiscount.buttons.remove.title',
        'Remove',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountApplyButtonTitle() {
      return this.$$t(
        'loyaltyDiscount.buttons.apply.title',
        'Apply',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountLoginMessage() {
      return this.$$t(
        'loyaltyDiscount.messages.login',
        'Please sign in to your account to use your loyalty points.',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountLoginButtonTitle() {
      return this.$$t(
        'loyaltyDiscount.buttons.login.title',
        'Login to existing account',
        this.loyaltyDiscountData
      )
    },

    loyaltyDiscountRegisterMessagePrefix() {
      return this.$$t(
        'loyaltyDiscount.messages.registerPrefix',
        'If you don\'t have an account, you can create it ',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountRegisterMessageSuffix() {
      return this.$$t(
        'loyaltyDiscount.messages.registerSuffix',
        '.',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountRegisterButtonTitle() {
      return this.$$t(
        'loyaltyDiscount.buttons.register.title',
        'here',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountNoPointMessage() {
      return this.$$t(
        'loyaltyDiscount.messages.noPoint',
        'You have 0 points. Earn 1 point per $[##earnRatio##] spent at location or online.',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountInsufficientPointsMessage() {
      return this.$$t(
        'loyaltyDiscount.messages.insufficient',
        'You have [##balance##] [###pluBalance##]points[##/pluBalance##][##^pluBalance##]point[##/pluBalance##]. ' +
        ' You currently don’t have enough loyalty points to complete this purchase using points. ' +
        '<br/>' +
        '<strong>Minimum required: [##min##] points.</strong>',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountSufficientPointsMessage() {
      return this.$$t(
        'loyaltyDiscount.messages.sufficient',
        'You have [##balance##] points. How many points would you like to use?',
        this.loyaltyDiscountData
      )
    },
    loyaltyDiscountSpendRatioMessage() {
      return this.$$t(
        'loyaltyDiscount.messages.spendRatio',
        'Loyalty perks: [##spendRatio##] points = $1 off',
        this.loyaltyDiscountData
      )
    },
  },
  methods: {
    getOverlappingReservationMessages(messages) {
      const isOverlapping = this.findOverlappingReservations()
      if (isOverlapping) {
        messages.push('You have reservations time overlapping for Ninja Wipeout and Race bookings. Please make sure to edit your time selection, if required.')
      }
    },
    findOverlappingReservations() {
      const items = _.pickBy(this.currentCartItems, ({type = null}) => type === raceType)
      const ninjas = _.pickBy(items, ({attributes: {raceType = null}}) => raceType === 'ninja')
      const pros = _.pickBy(items, ({attributes: {raceType = null}}) => raceType === 'pro')
      if (_.isEmpty(ninjas) || _.isEmpty(pros)) {
        return false
      }
      const ninjasTime = _.mapValues(ninjas, item => {
        const starts = parseDateTime(item.attributes.slot.datetime)
        const ends = starts.plus({hours: 1 * item.attributes.form.numberOfHours, minutes: 0, seconds: 1})
        const interval = starts.until(ends)//parseDateInterval
        return {interval, starts, ends}
      })
      const prosTime = _.mapValues(pros, item => {
        const slots = item.attributes.form.selectedSlots
        let starts = null
        let ends = null
        _.forOwn(slots, slot => {
          const slotStarts = parseDateTime(slot.datetime)
          const slotEnds = slotStarts.plus({minutes: 10, seconds: 1})
          if (_.isNil(starts)) {
            starts = slotStarts
          }
          if (_.isNil(ends)) {
            ends = slotEnds
          }
          if (slotStarts < starts) {
            starts = slotStarts
          }
          if (slotEnds > ends) {
            ends = slotEnds
          }
        })
        const interval = starts.until(ends)
        return {interval, starts, ends}
      })
      return _.some(ninjasTime, ninja => {
        return _.some(prosTime, pro => {
          return ninja.interval.overlaps(pro.interval)
        })
      })
    },
    showGeneralAlert() {
      if (this.isGeneralAlertVisible && this.generalAlertMessages.length) {
        this.generalAlertMessage = this.generalAlertMessages.shift() || null
        if (this.generalAlertMessage) {
          this.showGeneralAlertPopup()
        }
      }

    },
    hideGeneralAlert() {
      this.generalAlertMessage = ''
      this.showGeneralAlertPopup(false)
      this.showGeneralAlert()
    },

    async cartSubmitButtonClicked($event) {
      const args = {$event, items: this.currentCartItems, cart: this, click: {}}

      await EventBus.$$emitAsync('cart.process.before', args)

      if (args.click.cancel) {
        return
      }

      await this.tryGotoBilling()
    },

    async tryGotoBilling() {
      if (this.isValidating) {
        return
      }
      if (this.authUser) {
        this.gotoBilling()
      } else {
        const cardsOrSimpleOnly = Object.values(this.currentCartItems).filter(x => !(['gift_cards', 'playcard_voucher', 'playcard_reload', 'simple'].includes(x.type))).length === 0
        if (cardsOrSimpleOnly) {
          this.showCheckoutAsGuestModal = true
        } else {
          this.showLoginPrompt = true
        }
      }
    },

    async checkGuestEmail() {
      try {
        this.guestEmailRegistered = false
        this.isCheckingGuestEmail = true
        await axios.post(`${window.addiesaas.url}/api/user/register/validate-email`, { email: this.guestEmail })
        this.showCheckoutAsGuestModal = false
        this.guestEmailRegistered = false
        this.gotoBilling()
      } catch (e) {
        this.guestEmailRegistered = true
      } finally {
        this.isCheckingGuestEmail = false
      }
    },

    gotoBilling() {
      if (this.billingEnabled) {
        this.setBillingTotal(this.costDetails)
        this.setBillingGuestEmail(this.guestEmail)
        this.setCheckoutState('billing')
      } else {
        this.$once('cart.processing.error', async (e) => {
          await this.$nextTick()
          if (this.validationError === 'Unknown error!') {
            const message = 'Unfortunately, there are issues with this order. Please try one more time later.'
            this.setValidationError(message)
          }
        })
        this.$once('paid', () => {
          this.stopTimer()
          this.clearCartItems()
          this.setCheckoutState('final')
        })
        this.submitCart({})
      }
    },
    async gotoLoginPage(section, subSection) {
      const cartPage = 'page-cart'
      await this.setPostLoginPage(cartPage)
      await this.setPostLoginSection((section || 'billing') + '#' + (subSection || ''))
      this.gotoLogin()
      // this.showLoginPrompt = false
    },
    async gotoSignUpPage(section, subSection) {
      const cartPage = 'page-cart'
      await this.setPostLoginPage(cartPage)
      await this.setPostLoginSection((section || 'billing') + '#' + (subSection || ''))
      this.gotoRegistration()
      // this.showLoginPrompt = false
    },
    goBackFromCart() {
      EventBus.$emit('cart-go-back', this)
      window.location.href = '/'
    },
    cleanMyCart() {
      this.showClearCartPrompt = true
    },
    finallyCleanMyCart() {
      EventBus.$emit('cart-cleaned', this)
      this.clearCartItems()
      this.showClearCartPrompt = false
    },
    finallyDontCleanMyCart() {
      this.showClearCartPrompt = false
    },

    async addCoupon() {
      const code = this.coupon.code
      const codeExists = this.isCouponExists(code)

      if (codeExists) {
        this.coupon.error = 'This code is already added.'
        return
      }
      this.resetCouponInput()

      try {
        this.coupon.isAdding = true
        await this.$nextTick()

        const options = {code}
        await axios.post(`${window.addiesaas.url}/api/customer/coupon/check`, options)

        await this.addDiscount({
          id: `coupon_${code}`,
          title: code,
          type: 'coupon',
          payload: {
            type: 'coupon',
            options
          },
        })

        this.coupon.error = null
        await EventBus.$$emitAsync('cart.validate')

        await this.$nextTick()
        const appliedData = this.getCouponData(code)
        const isApplied = appliedData && appliedData.applied
        this.coupon.isAdded = isApplied
        this.coupon.notApplied = !isApplied
        if (!isApplied) {
          const message = this.getCouponError(appliedData, 'Coupon can not be applied.')
          this.coupon.error = message
        } else {
          this.coupon.code = null
        }

      } catch (e) {
        this.coupon.error = getFirstErrorMessage(e)
      } finally {
        await this.$nextTick()
        this.coupon.isAdding = false
      }
    },

    coupons(summary) {
      const discounts = _.get(summary, 'discounts.data', [])
      return discounts.filter(x => x.type === 'coupon')
    },

    couponsTotal(summary) {
      const initial = {
        fee_discount: 0,
        fee_tax_discount: 0,
        price_discount: 0,
        tax_discount: 0,
      }
      const coupons = this.coupons(summary)
      if (coupons.length > 0) {
        return coupons.reduce((a, x) => {
          return {
            fee_discount: a.fee_discount + x.fee_discount,
            fee_tax_discount: a.fee_tax_discount + x.fee_tax_discount,
            price_discount: a.price_discount + x.price_discount,
            tax_discount: a.tax_discount + x.tax_discount,
          }
        }, initial)
      } else {
        return initial
      }
    },

    deleteCoupon(code) {
      const coupon = Object
        .values(this.cartDiscounts)
        .filter(x => x.type === 'coupon' && x.payload.options.code === code)
        .forEach(discount => {
          this.removeCartDiscount({ id: discount.id })
        })
        this.resetCouponInput(true)
        EventBus.$emit('cart.validate')
    },

    async addGiftcard() {
      this.resetGiftcardInput()
      try {
        this.giftcard.isAdding = true

        this.giftcard.options = {
          number: this.giftcard.number,
          cvv: this.giftcard.cvv,
        }

        const { data: { data: giftcard } } = await axios.post(`${window.addiesaas.url}/api/customer/giftcard/check`, this.giftcard.options)

        this.giftcard.options.amount = Number(giftcard.balance)
        this.showGiftcardFullPartialModal = true
      } catch (e) {
        this.giftcard.error = getFirstErrorMessage(e)
      } finally {
        this.giftcard.isAdding = false
      }
    },

    async applyGiftcard(amount) {
      this.showGiftcardFullPartialModal = this.showGiftcardAmountModal = false

      const id = `giftcard_${this.giftcard.number}`

      if (amount !== null) {
        amount = Number(amount)

        if (id in this.cartDiscounts) {
          amount += this.cartDiscounts[id].payload.options.amount
        }

        if (amount > this.giftcard.options.amount) {
          this.giftcard.error = 'The selected amount is not available on your Gift Card.'
          return
        }

        this.giftcard.options.amount = amount
      }

      this.resetGiftcardInput()

      this.giftcard.isAdding = true

      this.addDiscount({
        id,
        title: this.giftcard.number,
        type: 'giftcard',
        payload: {
          type: 'giftcard',
          options: this.giftcard.options
        },
      })

      this.$set(this.giftcard, 'number', null)
      this.$set(this.giftcard, 'cvv', null)

      try {
        this.giftcard.error = null
        await EventBus.$$emitAsync('cart.validate')

        await this.$nextTick()
        const appliedData = this.getGiftcardData(id)
        const isApplied = _.get(appliedData, 'discount.applied')

        this.giftcard.isAdded = isApplied
        this.giftcard.notApplied = !isApplied

        if (isApplied) {
          this.giftcard.number = null
          this.giftcard.cvv = null
          this.giftcard.amount = null
        } else {
          this.giftcard.itemId = id
          const message = this.getGiftcardError(appliedData, 'Gift card is not applied.')
          this.giftcard.error = message
        }
      } catch (e) {
        this.giftcard.error = getFirstErrorMessage(e)
      } finally {
        await this.$nextTick()
        this.giftcard.isAdding = false
      }
    },

    giftcards(summary) {
      return Object
        .values(this.cartDiscounts)
        .filter(x => x.type === 'giftcard')
        .map(x => {
          const discount = summary ?
            summary.discounts.data.find(y => y.type === 'giftcard' && y.options.number === x.payload.options.number) : {}
          return Object.assign({}, x, { discount })
        })
    },

    giftcardsDiscount(summary) {
      if (summary) {
        return summary.discounts.data
          .filter(x => x.type === 'giftcard')
          .map(x => -(x.price_discount + x.tax_discount))
          .reduce((total, x) => total + x, 0)
      }
    },

    deleteGiftcard(id) {
      this.removeCartDiscount({ id })
      this.resetGiftcardInput(true)
      EventBus.$emit('cart.validate')
    },

    switchRedemptionPanel(type) {
      this.selectedRedemption = type
      this.resetCouponInput(true)
      this.resetGiftcardInput(true)
    },
    resetGiftcardInput(clean) {
      this.giftcard.isAdded = false
      this.giftcard.error = null
      this.giftcard.notApplied = false
      this.giftcard.itemId = null
      if (clean) {
        this.giftcard.cvv = null
        this.giftcard.number = null
        this.giftcard.amount = null
      }
    },
    resetCouponInput(clean) {
      this.coupon.isAdded = false
      this.coupon.error = null
      this.coupon.notApplied = false
      if (clean) {
        this.coupon.code = null
      }
    },
    getCouponData(code) {
      const discounts = this.coupons(this.costDetails)
      return _.find(discounts, x => x.options.code === code)
    },
    isCouponExists(code) {
      return !!this.getCouponData(code)
    },
    getGiftcardData(id) {
      const discounts = this.giftcards(this.costDetails)
      return _.find(discounts, x => x.id === id && x.discount)
    },
    getCouponError(coupon, defaultMessage = 'Not applied') {
      return _.get(coupon, 'messages.errors.0') || defaultMessage
    },
    getGiftcardError(giftcard, defaultMessage = 'Not applied') {
      return _.get(giftcard, 'discount.messages.errors.0') || defaultMessage
    },

    calculateLoyaltyRedemption(points) {
      return points / this.loyaltyPointSpendRatio
    },
    loyaltyDiscounts(summary) {
      const discounts = _.get(summary || this.costDetails, 'discounts.data', [])
      return discounts.filter(x => x.type === LOYALTY_DISCOUNT_TYPE)
    },
    countDiscountTotal(discount) {
      discount = discount || {}
      return _.toFinite(discount.price_discount) +
        _.toFinite(discount.fee_discount) +
        _.toFinite(discount.fee_tax_discount) +
        _.toFinite(discount.shipping_fee_discount) +
        _.toFinite(discount.shipping_fee_tax_discount) +
        _.toFinite(discount.tax_discount)
    },
    getLoyaltyDiscountsTotal() {
      return _.reduce(this.loyaltyDiscounts, (total, d) => {
        return total + this.countDiscountTotal(d)
      }, 0)
    },
    resetLoyaltyInput(clean) {
      const loyalty = this.loyalty
      loyalty.isAdding = false
      loyalty.isAdded = false
      loyalty.error = null
      if (clean) {
        loyalty.points = null
      }
    },
    getLoyaltyError(defaultMessage) {
      return this.loyalty.error || defaultMessage
    },
    async addLoyalty() {
      this.resetLoyaltyInput()
      const loyalty = this.loyalty
      const points = loyalty.points
      const invalid = this.$v.loyalty.$invalid

      const canCheckBelowMin = !!this.$$s('loyaltyDiscount.validate.pointsBelowMin', true)
      const canCheckBelowRatio = !!this.$$s('loyaltyDiscount.validate.pointsBelowSpendRatio', true)
      const canCheckAboveMax = !!this.$$s('loyaltyDiscount.validate.pointsAboveMax', true)
      const canCheckAboveUser = !!this.$$s('loyaltyDiscount.validate.pointsAboveUser', true)

      if (canCheckBelowMin && points < this.loyaltyPointMinSpend) {
        loyalty.error = this.$$t(
          'loyaltyDiscount.errors.pointsBelowMin',
          'Your applied loyalty points are too low.',
          this.loyaltyDiscountData
        )
        return
      }
      if (canCheckBelowRatio && points < this.loyaltyPointSpendRatio) {
        loyalty.error = this.$$t(
          'loyaltyDiscount.errors.pointsBelowSpendRatio',
          'Insufficient loyalty points applied.',
          this.loyaltyDiscountData
        )
        return
      }
      if (canCheckAboveMax && points > this.loyaltyPointMaxSpend) {
        loyalty.error = this.$$t(
          'loyaltyDiscount.errors.pointsAboveMax',
          'Your applied loyalty points are too high.',
          this.loyaltyDiscountData
        )
        return
      }
      if (canCheckAboveUser && points > this.userLoyaltyPoints) {
        loyalty.error = this.$$t(
          'loyaltyDiscount.errors.pointsAboveUser',
          'You do not have loyalty points are too high.',
          this.loyaltyDiscountData
        )
        return
      }
      if (invalid) {
        loyalty.error = this.$$t(
          'loyaltyDiscount.errors.invalid',
          'Unable to use loyalty points.',
          this.loyaltyDiscountData
        )
        return
      }

      try {
        loyalty.isAdding = true
        await this.deleteLoyalty(true, true)
        await this.$nextTick()

        const discounts = _.values(_.mapValues(this.cartDiscounts || {}, 'payload'))
        const loayltyPayload = {
          type: LOYALTY_DISCOUNT_TYPE,
          options: {
            points
          }
        }
        discounts.push(loayltyPayload)

        const payload = {
          items: _.values(_.mapValues(this.currentCartItems, 'payload')),
          discounts,
        }

        let data = await MainService.validateOrder(payload)
        const appliedDiscounts = _.get(data, 'data.discounts.data')
        const appliedData = _.find(appliedDiscounts, d => d.type === LOYALTY_DISCOUNT_TYPE)
        const isApplied = appliedData && appliedData.applied
        loyalty.isAdded = isApplied
        if (isApplied) {
          const id = LOYALTY_DISCOUNT_TYPE + '_' + points
          await this.addDiscount({
            id,
            title: 'Loyalty points: ' + points,
            type: LOYALTY_DISCOUNT_TYPE,
            payload: {
              type: LOYALTY_DISCOUNT_TYPE,
              options: {
                points
              }
            },
          })
          EventBus.$emit('cart.validate')
        } else {
          const message = this.$$t(
            'loyaltyDiscount.errors.notApplied',
            'Your loyalty points can not be applied.',
            {...appliedData, points}
          )
          loyalty.error = message
        }
      } catch (e) {
        await this.deleteLoyalty(true, true)
        loyalty.error = getFirstErrorMessage(e)
      } finally {
        await this.$nextTick()
        loyalty.isAdding = false
      }
    },
    async deleteLoyalty(skipValidation, skipReset) {
      for(let {id, type} of _.values(this.cartDiscounts)) {
        if (type === LOYALTY_DISCOUNT_TYPE) {
          await this.removeCartDiscount({id})
        }
      }
      if (!skipReset) {
        this.resetLoyaltyInput(true)
      }
      if (!skipValidation) {
        EventBus.$emit('cart.validate')
      }
    },
    getFirstErrorMessage(e, defaultMessage) {
      return getFirstErrorMessage(e, defaultMessage)
    },
    gotoSubSection(name) {
      if (name === 'loyalty') {
        this.switchRedemptionPanel('loyalty')
        this.scrollTo('redemptions-switch.redemptions-switch__loyalty')
        document.querySelector('input.loyalty-number')?.focus()
      }
      if (name === 'coupon') {
        this.switchRedemptionPanel('coupon')
        this.scrollTo('redemptions-switch.redemptions-switch__coupon')
        document.querySelector('input.coupon-code')?.focus()
      }
      if (name === 'giftcard') {
        this.switchRedemptionPanel('giftcard')
        this.scrollTo('redemptions-switch.redemptions-switch__giftcard')
        document.querySelector('input.gift-card-number')?.focus()
      }
    }
  }
}
